import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import axios from "axios";
import { Form } from "react-bootstrap";
import Gallery from "react-grid-gallery";
import _ from "lodash";
import { ReactDropZoneWidget } from "../../index";
import PhotoItem from "./components/PhotoItem";

var ReactPhotoGalleryField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactPhotoGalleryField, _React$Component);

  function ReactPhotoGalleryField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleRemoveFile", function (index) {
      var _this$props = _this.props,
          formData = _this$props.formData,
          onChange = _this$props.onChange;
      var attachments = formData;

      var newAttachments = _.reject(attachments || [], function (item, i) {
        return i === index;
      });

      onChange && onChange(newAttachments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAcceptFiles", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(acceptedFiles) {
        var onChange, _ref2, fileUploadUrl, authenticityToken, formData, response, responseData, attachments, promises, allPromises, attachmentsWithMetaData, newAttachments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                onChange = _this.props.onChange;
                _ref2 = _.get(_this.props, "options") || {}, fileUploadUrl = _ref2.fileUploadUrl, authenticityToken = _ref2.authenticity_token;
                formData = _this.createFormData(acceptedFiles, authenticityToken);
                _context2.next = 5;
                return axios.post(fileUploadUrl, formData, {
                  headers: {
                    Accept: "application/json",
                    "X-CSRF-Token": authenticityToken
                  }
                });

              case 5:
                response = _context2.sent;
                responseData = _.get(response, "data");
                attachments = _this.getAttachments();
                promises = responseData.map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(attachment) {
                    var dimensions;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.getImageDimensions(attachment.url);

                          case 2:
                            dimensions = _context.sent;
                            return _context.abrupt("return", _extends({}, attachment, dimensions));

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                allPromises = Promise.all(promises);
                _context2.next = 12;
                return allPromises;

              case 12:
                attachmentsWithMetaData = _context2.sent;

                if (_.isArray(responseData)) {
                  newAttachments = [].concat(attachments, attachmentsWithMetaData);
                  onChange && onChange(newAttachments);
                } else {
                  attachments.push(attachmentsWithMetaData);
                  onChange && onChange(attachments);
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderPhotos", function (item) {
      return /*#__PURE__*/React.createElement(PhotoItem, _extends({}, item, {
        key: item.index,
        isColumn: _this.isColumnLayout(),
        onRemove: _this.handleRemoveFile
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "getImageDimensions", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
        var imageDimensions;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                imageDimensions = function imageDimensions(url) {
                  return new Promise(function (resolve, reject) {
                    var img = new Image(); // the following handler will fire after the successful loading of the image

                    img.onload = function () {
                      var width = img.naturalWidth,
                          height = img.naturalHeight;
                      resolve({
                        width: width,
                        height: height
                      });
                    }; // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)


                    img.onerror = function () {
                      reject('There was some problem with the image.');
                    };

                    img.src = url;
                  });
                };

                _context3.next = 3;
                return imageDimensions(url);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());

    return _this;
  }

  var _proto = ReactPhotoGalleryField.prototype;

  _proto.isDisabled = function isDisabled() {
    var _this$props2 = this.props,
        readonly = _this$props2.readonly,
        readOnly = _this$props2.readOnly,
        disabled = _this$props2.disabled;
    var isDisabled = readonly || readOnly || disabled;
    return isDisabled;
  };

  _proto.createFormData = function createFormData(acceptedFiles, authenticityToken) {
    var data = new FormData();

    for (var _iterator = _createForOfIteratorHelperLoose(acceptedFiles), _step; !(_step = _iterator()).done;) {
      var file = _step.value;
      data.append("attachments", file, file.name);
    }

    data.append("authenticity_token", authenticityToken);
    return data;
  };

  _proto.getAttachments = function getAttachments() {
    var attachments = _.get(this.props, "formData", []) || [];

    if (_.isArray(attachments)) {
      return attachments;
    } else {
      return [];
    }
  };

  _proto.renderGallery = function renderGallery() {
    var _this2 = this;

    var rowHeight = this.props.rowHeight;

    var images = _.map(this.getAttachments(), function (_ref5) {
      var url = _ref5.url,
          width = _ref5.width,
          height = _ref5.height;
      return {
        src: url,
        thumbnail: url,
        thumbnailWidth: width || 500,
        thumbnailHeight: height || 500
      };
    });

    return /*#__PURE__*/React.createElement(Gallery, {
      rowHeight: rowHeight || 400,
      onSelectImage: this.handleRemoveFile,
      enableLightbox: false,
      thumbnailImageComponent: function thumbnailImageComponent(imageProps) {
        return /*#__PURE__*/React.createElement(PhotoItem, _extends({
          onDeleteButtonClick: function onDeleteButtonClick() {
            return _this2.handleRemoveFile(imageProps.index);
          }
        }, imageProps));
      },
      enableImageSelection: false,
      images: images
    });
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        schema = _this$props3.schema,
        uploadComponent = _this$props3.uploadComponent;
    var UploadComponent = uploadComponent || ReactDropZoneWidget;
    return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, schema.title), /*#__PURE__*/React.createElement("div", {
      className: "react-gallery"
    }, !this.isDisabled() && /*#__PURE__*/React.createElement(UploadComponent, {
      title: schema.title,
      accepted: ["image/*"],
      onAcceptedFiles: this.handleAcceptFiles,
      className: "d-print-none"
    }), /*#__PURE__*/React.createElement("div", null, this.renderGallery())));
  };

  return ReactPhotoGalleryField;
}(React.Component);

export default ReactPhotoGalleryField;